import { useMemo, useState } from "react";
import { ApiFarmGate, ApiProcessGate } from "../../../../types/prodcut-data-review/product-data.types";

/** Free-text filter over the farm/process gate lists by name. */
export const useGateSearch = (farmGates: ApiFarmGate[], processGates: ApiProcessGate[]) => {
  const [q, setQ] = useState("");

  const filteredFarmGates = useMemo(
    () => (q ? farmGates.filter(g => g.farmGateName.toLowerCase().includes(q.toLowerCase())) : farmGates),
    [farmGates, q]
  );

  const filteredProcessGates = useMemo(
    () =>
      q
        ? processGates.filter(g => g.processGateName.toLowerCase().includes(q.toLowerCase()))
        : processGates,
    [processGates, q]
  );

  return { q, setQ, filteredFarmGates, filteredProcessGates };
};
